import PessoaTipoSelect from "./PessoaTipo/PessoaTipoSelect";

import { Col, Form, Row, Select } from "antd";
import { EnumPessoaTipo, TypePessoa } from "../../../Models/Pessoa/Pessoa";
import { NamePath } from "antd/lib/form/interface";
import { Rule } from "antd/es/form";
import { SelectComPesquisa } from "../../SelectComPesquisa";
import { ReactNode, useEffect, useMemo, useRef } from "react";
import { useListar } from "../../../Services/Pessoa/PessoaService";

type InputProps = "tipo" | "*";

interface IPessoaSelectComTipoProps<T> extends Omit<React.ComponentProps<typeof Select>, "showSearch" | "optionFilterProp" | "filterOption"> {
    placeholderTipo?:string,
    tiposPessoaValidos?:number[]|EnumPessoaTipo[],
    tiposPessoaInValidos?:number[]|EnumPessoaTipo[],
    names: { [ key in InputProps ] : NamePath<T> },
    rules?: { [ key in InputProps ] : Rule[] },
    label?:ReactNode
}
export default function PessoaSelectComTipo<T> ({
    placeholder,
    placeholderTipo,
    allowClear,
    tiposPessoaValidos,
    tiposPessoaInValidos,
    label,
    names,
    rules,
    ...rest
}:IPessoaSelectComTipoProps<T>) {         
    const form = Form.useFormInstance<T>();

    if (form == undefined) throw new Error("O componente deve estar aninhado em um formulário");

    const codTipoState = Form.useWatch(names["tipo"], form);

    return <Row style={{width : "100%"}} gutter={8} wrap>
        <Col xs={8}>
            <Form.Item<TypePessoa> style={{
                marginBottom : 0
            }} label={placeholderTipo ?? `Tp. ${label ?? "Pessoa"}`} name={names["tipo"] as NamePath<TypePessoa>} rules={rules == undefined ? undefined : rules["tipo"]}>
                <PessoaTipoSelect
                    tiposPessoaValidos={tiposPessoaValidos}
                    tiposPessoaInValidos={tiposPessoaInValidos}
                    // onChange={(value) => {
                    //     if (rest?.mode != "multiple")
                    //         form.setFieldValue(names["*"], undefined);
                    //     form.setFieldValue(names["tipo"], value);
                    // }}
                    disabled={rest.disabled}
                />
            </Form.Item>
        </Col>
        <Col xs={16}>
            <Form.Item<TypePessoa>
                label={label ?? "Pessoa"}
                name={names["*"] as NamePath<TypePessoa>}
                rules={rules == undefined ? undefined : rules["*"]}
                style={{marginBottom: 0}}
            >
                <PessoaSelect 
                    tipoPessoa={codTipoState} 
                    allowClear={allowClear ?? true}
                    placeholder={placeholder ?? "Selecione uma pessoa"}
                    {...rest}
                />
            </Form.Item>
    
        </Col>
    </Row>;
}

interface IPessoaSelectProps extends Omit<React.ComponentProps<typeof Select>, "showSearch" | "optionFilterProp" | "filterOption" | "onChange"> {
    tipoPessoa?:number|EnumPessoaTipo;
    tiposPessoaValidos?:number[]|EnumPessoaTipo[];
    tiposPessoaInValidos?:number[]|EnumPessoaTipo[];
    comIncludes?:boolean;
    onChange?:(value:number|undefined, record:TypePessoa|undefined) => void;
}

export function PessoaSelect({ 
    tipoPessoa, 
    tiposPessoaValidos, 
    tiposPessoaInValidos, 
    comIncludes,
    placeholder, 
    allowClear, 
    onChange, 
    value, 
    ...props 
}: IPessoaSelectProps) : JSX.Element {
    const refSelect = useRef(null);
    const { data, isLoading } = useListar({
        pessoa: {
            tipo: tipoPessoa,
        },
        ativo: true,
        tiposPessoaValidos : tiposPessoaValidos,
        tiposPessoaInValidos : tiposPessoaInValidos,
        comIncludes : comIncludes ?? false
        //enabled: tipoPessoa != undefined && tipoPessoa != null && tipoPessoa > 0
    });

    const options = useMemo(() => {
        return (data ?? []).map((m) => {
            return {
                value: m.codigo,
                label: `${m.nomeExibicao}${(m.documentoExibicao ?? "").trim() === "" ? "" : " (" + m.documentoExibicao + ")"}`,
            };
        });
    }, [data]);

    useEffect(() => {
        if (value === undefined || (typeof value === "string" && value.trim() === ''))
        {
            if (options?.length === 1) onChange?.(options[0].value, (data ?? [])?.find?.(f => f.codigo === options[0].value));
        }
    }, [value, options]);

    return (
        <SelectComPesquisa
            {...props}
            ref={refSelect}
            placeholder={placeholder ?? "Selecione"}
            allowClear={allowClear ?? true}
            loading={isLoading}
            onChange={(v) => {
                onChange?.(
                    typeof v === "number" || typeof v === "string" 
                        ? Number.parseInt(v.toString()) 
                        : undefined, 
                    data?.find?.(f => f.codigo === Number.parseInt(v as any)) ?? undefined
                );
            }}
            value={value}
            options={options}
        />
    );
}